import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ReportDetailService from "services/reportDetailService";

const getExportFileName = (exportType) => {
  const map = {
    1: "Báo cáo đơn hàng.xlsx",
    2: "Báo cáo hiệu suất sản phẩm.xlsx",
    3: "Báo cáo hiệu suất nhân viên.xlsx",
    4: "Báo cáo tổng quan khách hàng.xlsx",
    5: "Báo cáo hiệu quả khuyến mãi.xlsx",
    6: "Báo cáo xu hướng.xlsx",
    7: "Báo cáo hiệu quả kinh doanh P&L.xlsx",
    8: "Báo cáo dòng tiền thanh toán.xlsx",
    9: "Báo cáo thu chi và công nợ.xlsx",
    10: "Báo cáo bảng kê hóa đơn.xlsx",
    11: "Báo cáo chi tiết nhập xuất kho.xlsx",
    12: "Báo cáo kiểm soát hao hụt kho.xlsx",
    13: "Báo cáo kiểm soát rủi ro.xlsx",
    14: "Báo cáo nhà cung cấp.xlsx",
    15: "Báo cáo tổng hợp tồn kho.xlsx",
  };

  return map[exportType] || "Báo cáo chi tiết.xlsx";
};

export const getOrderDetailReport = createAsyncThunk(
  "reportDetail/getOrderDetail",
  async (params, { rejectWithValue }) => {
    try {
      const res = await ReportDetailService.getOrderDetail(params);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getProductPerformanceReport = createAsyncThunk(
  "reportDetail/getProductPerformance",
  async (params, { rejectWithValue }) => {
    try {
      const res = await ReportDetailService.getProductPerformance(params);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getEmployeePerformanceReport = createAsyncThunk(
  "reportDetail/getEmployeePerformance",
  async (params, { rejectWithValue }) => {
    try {
      const res = await ReportDetailService.getEmployeePerformance(params);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getCustomerOverviewReport = createAsyncThunk(
  "reportDetail/getCustomerOverview",
  async (params, { rejectWithValue }) => {
    try {
      const res = await ReportDetailService.getCustomerOverview(params);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getInvoiceReport = createAsyncThunk(
  "reportDetail/getInvoice",
  async (params, { rejectWithValue }) => {
    try {
      const res = await ReportDetailService.getInvoice(params);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getTrendReport = createAsyncThunk(
  "reportDetail/getTrend",
  async (params, { rejectWithValue }) => {
    try {
      const res = await ReportDetailService.getTrend(params);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getOrderRiskControlReport = createAsyncThunk(
  "reportDetail/getOrderRiskControl",
  async (params, { rejectWithValue }) => {
    try {
      const res = await ReportDetailService.getOrderRiskControl(params);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getInventoryLossReport = createAsyncThunk(
  "reportDetail/getInventoryLoss",
  async (params, { rejectWithValue }) => {
    try {
      const res = await ReportDetailService.getInventoryLoss(params);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getInventoryOverviewReport = createAsyncThunk(
  "reportDetail/getInventoryOverview",
  async (params, { rejectWithValue }) => {
    try {
      const res = await ReportDetailService.getInventoryOverview(params);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getCashBookDebtReport = createAsyncThunk(
  "reportDetail/getCashBookDebt",
  async (params, { rejectWithValue }) => {
    try {
      const res = await ReportDetailService.getCashBookDebt(params);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getPaymentCashFlowReport = createAsyncThunk(
  "reportDetail/getPaymentCashFlow",
  async (params, { rejectWithValue }) => {
    try {
      const res = await ReportDetailService.getPaymentCashFlow(params);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getProfitLossReport = createAsyncThunk(
  "reportDetail/getProfitLossReport",
  async (params, { rejectWithValue }) => {
    try {
      const res = await ReportDetailService.getProfit(params);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getSupplierReport = createAsyncThunk(
  "reportDetail/getSupplier",
  async (params, { rejectWithValue }) => {
    try {
      const res = await ReportDetailService.getSupplier(params);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getPromotionEffectReport = createAsyncThunk(
  "reportDetail/getPromotionEffect",
  async (params, { rejectWithValue }) => {
    try {
      const res = await ReportDetailService.getPromotionEffect(params);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getInventorySummaryReport = createAsyncThunk(
    "reportDetail/getInventorySummaryReport",
    async (params, { rejectWithValue }) => {
      try {
        const res = await ReportDetailService.getInventorySummary(params);
        return res.data;
      } catch (err) {
        return rejectWithValue(err.message || "Error");
      }
    }
);

export const getSupplierFilter = createAsyncThunk(
    "reportDetail/getSupplierFilter",
    async (params, { rejectWithValue }) => {
      try {
        const res = await ReportDetailService.getSupplierFilter(params);
        return res.data;
      } catch (err) {
        return rejectWithValue(err.message || "Error");
      }
    }
);

// ===== EXPORT =====
export const exportReportDetailExcel = createAsyncThunk(
  "reportDetail/exportExcel",
  async (params, { rejectWithValue }) => {
    try {
      const res = await ReportDetailService.exportExcel(params);
      const blob = res.data || res;

      const url = window.URL.createObjectURL(blob);
      const filename = getExportFileName(
        params?.exportType || params?.ExportType
      );

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      return true;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

// ================= STATE =================
const initialState = {
  loadingOrderDetail: false,
  loadingProductPerformance: false,
  loadingEmployeePerformance: false,
  loadingCustomerOverview: false,
  loadingInvoice: false,
  loadingTrend: false,
  loadingOrderRiskControl: false,
  loadingInventoryLoss: false,
  loadingInventoryOverview: false,
  loadingCashBookDebt: false,
  loadingPaymentCashFlow: false,
  loadingProfitLoss: false,
  loadingSupplier: false,
  loadingPromotionEffect: false,
  loadingExport: false,
  loadingInventorySummary: false,
  
  orderDetailList: [],
  productPerformanceList: [],
  employeePerformanceList: [],
  customerOverviewList: [],
  invoiceList: [],
  trendList: [],
  orderRiskControlList: [],
  inventoryLossList: [],
  inventoryOverviewList: [],
  cashBookDebtList: [],
  paymentCashFlowList: [],
  profitLossList: [],
  supplierList: [],
  supplierFilterList: [],
  promotionEffectList: [],
  inventorySummaryList: [],
};

// ================= SLICE =================
export const reportDetailSlice = createSlice({
  name: "reportDetail",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      // ORDER
      .addCase(getOrderDetailReport.pending, (s) => {
        s.loadingOrderDetail = true;
      })
      .addCase(getOrderDetailReport.fulfilled, (s, a) => {
        s.loadingOrderDetail = false;
        s.orderDetailList = a.payload;
      })
      .addCase(getOrderDetailReport.rejected, (s) => {
        s.loadingOrderDetail = false;
      })

      // PRODUCT
      .addCase(getProductPerformanceReport.pending, (s) => {
        s.loadingProductPerformance = true;
      })
      .addCase(getProductPerformanceReport.fulfilled, (s, a) => {
        s.loadingProductPerformance = false;
        s.productPerformanceList = a.payload;
      })
      .addCase(getProductPerformanceReport.rejected, (s) => {
        s.loadingProductPerformance = false;
      })

      // EMPLOYEE
      .addCase(getEmployeePerformanceReport.pending, (s) => {
        s.loadingEmployeePerformance = true;
      })
      .addCase(getEmployeePerformanceReport.fulfilled, (s, a) => {
        s.loadingEmployeePerformance = false;
        s.employeePerformanceList = a.payload;
      })
      .addCase(getEmployeePerformanceReport.rejected, (s) => {
        s.loadingEmployeePerformance = false;
      })

      // CUSTOMER
      .addCase(getCustomerOverviewReport.pending, (s) => {
        s.loadingCustomerOverview = true;
      })
      .addCase(getCustomerOverviewReport.fulfilled, (s, a) => {
        s.loadingCustomerOverview = false;
        s.customerOverviewList = a.payload;
      })
      .addCase(getCustomerOverviewReport.rejected, (s) => {
        s.loadingCustomerOverview = false;
      })

      // INVOICE
      .addCase(getInvoiceReport.pending, (s) => {
        s.loadingInvoice = true;
      })
      .addCase(getInvoiceReport.fulfilled, (s, a) => {
        s.loadingInvoice = false;
        s.invoiceList = a.payload;
      })
      .addCase(getInvoiceReport.rejected, (s) => {
        s.loadingInvoice = false;
      })

      // TREND
      .addCase(getTrendReport.pending, (s) => {
        s.loadingTrend = true;
      })
      .addCase(getTrendReport.fulfilled, (s, a) => {
        s.loadingTrend = false;
        s.trendList = a.payload;
      })
      .addCase(getTrendReport.rejected, (s) => {
        s.loadingTrend = false;
      })

      // RISK
      .addCase(getOrderRiskControlReport.pending, (s) => {
        s.loadingOrderRiskControl = true;
      })
      .addCase(getOrderRiskControlReport.fulfilled, (s, a) => {
        s.loadingOrderRiskControl = false;
        s.orderRiskControlList = a.payload;
      })
      .addCase(getOrderRiskControlReport.rejected, (s) => {
        s.loadingOrderRiskControl = false;
      })

      // LOSS
      .addCase(getInventoryLossReport.pending, (s) => {
        s.loadingInventoryLoss = true;
      })
      .addCase(getInventoryLossReport.fulfilled, (s, a) => {
        s.loadingInventoryLoss = false;
        s.inventoryLossList = a.payload;
      })
      .addCase(getInventoryLossReport.rejected, (s) => {
        s.loadingInventoryLoss = false;
      })

      // OVERVIEW
      .addCase(getInventoryOverviewReport.pending, (s) => {
        s.loadingInventoryOverview = true;
      })
      .addCase(getInventoryOverviewReport.fulfilled, (s, a) => {
        s.loadingInventoryOverview = false;
        s.inventoryOverviewList = a.payload;
      })
      .addCase(getInventoryOverviewReport.rejected, (s) => {
        s.loadingInventoryOverview = false;
      })

      // DEBT
      .addCase(getCashBookDebtReport.pending, (s) => {
        s.loadingCashBookDebt = true;
      })
      .addCase(getCashBookDebtReport.fulfilled, (s, a) => {
        s.loadingCashBookDebt = false;
        s.cashBookDebtList = a.payload;
      })
      .addCase(getCashBookDebtReport.rejected, (s) => {
        s.loadingCashBookDebt = false;
      })

      // CASH FLOW
      .addCase(getPaymentCashFlowReport.pending, (s) => {
        s.loadingPaymentCashFlow = true;
      })
      .addCase(getPaymentCashFlowReport.fulfilled, (s, a) => {
        s.loadingPaymentCashFlow = false;
        s.paymentCashFlowList = a.payload;
      })
      .addCase(getPaymentCashFlowReport.rejected, (s) => {
        s.loadingPaymentCashFlow = false;
      })

      // PROFIT
      .addCase(getProfitLossReport.pending, (s) => {
        s.loadingProfitLoss = true;
      })
      .addCase(getProfitLossReport.fulfilled, (s, a) => {
        s.loadingProfitLoss = false;
        s.profitLossList = a.payload;
      })
      .addCase(getProfitLossReport.rejected, (s) => {
        s.loadingProfitLoss = false;
      })

      // SUPPLIER
      .addCase(getSupplierReport.pending, (s) => {
        s.loadingSupplier = true;
      })
      .addCase(getSupplierReport.fulfilled, (s, a) => {
        s.loadingSupplier = false;
        s.supplierList = a.payload;
      })
      .addCase(getSupplierReport.rejected, (s) => {
        s.loadingSupplier = false;
      })
      .addCase(getSupplierFilter.fulfilled, (s, a) => {
        s.loadingSupplier = false;
        s.supplierFilterList = a.payload;
      })

      // PROMOTION EFFECT
      .addCase(getPromotionEffectReport.pending, (s) => {
        s.loadingPromotionEffect = true;
      })
      .addCase(getPromotionEffectReport.fulfilled, (s, a) => {
        s.loadingPromotionEffect = false;
        s.promotionEffectList = a.payload;
      })
      .addCase(getPromotionEffectReport.rejected, (s) => {
        s.loadingPromotionEffect = false;
      })

      // EXPORT
      .addCase(exportReportDetailExcel.pending, (s) => {
        s.loadingExport = true;
      })
      .addCase(exportReportDetailExcel.fulfilled, (s) => {
        s.loadingExport = false;
      })
      .addCase(exportReportDetailExcel.rejected, (s) => {
        s.loadingExport = false;
      })

      // SUMMARY WAREHOUSE
      .addCase(getInventorySummaryReport.pending, (s) => {
        s.loadingInventorySummary = true;
      })
      .addCase(getInventorySummaryReport.fulfilled, (s, a) => {
        s.loadingInventorySummary = false;
        s.inventorySummaryList = a.payload;
      })
      .addCase(getInventorySummaryReport.rejected, (s) => {
        s.loadingInventorySummary = false;
      });
  },
});

export default reportDetailSlice.reducer;